import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_VIEWPORTS } from './api/query'
import { Data, Variables, ViewportSliceDTO } from './api/types'
import { Props, UseGetViewports, ViewportSlice } from './types'

export const useGetViewports = ({ filters, sort, workspaceId }: Props): UseGetViewports => {
  const { isLoading, refetch } = useQuery<Variables, Data, ViewportSlice[]>({
    options: {
      enabled: workspaceId !== undefined,
      select: ({ viewports: { nodes } }: Data): ViewportSlice[] =>
        nodes?.map((node: ViewportSliceDTO): ViewportSlice => fromDTO(node)) ?? [],
      staleTime: Infinity,
    },
    query: GET_VIEWPORTS,
    variables: {
      sort,
      terms: filters,
      workspaceId,
    },
  })

  const lazyGetViewports = async (): Promise<ViewportSlice[]> => {
    return (await refetch()).data ?? []
  }

  return {
    lazyGetViewports,
    loading: isLoading,
  }
}
